import { Grid, Tab, Tabs, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import AuthContext from '../../store/auth-context';
import FirstStageTable from './StagesTables/FirstStageTable';
import OlympicsContext from '../../store/olympics-context';
import SecondAStageTable from './StagesTables/SecondAStageTable';
import SecondBStageTable from './StagesTables/SecondBStageTable';
import ThirdAStageTable from './StagesTables/ThirdAStageTable';
import ThirdBStageTable from './StagesTables/ThirdBStageTable';
import { useCustomTheme } from '../../store/theme-context';
import Teacher from '../../model/Teacher';
import StudentsStagesTable from './StudentsStagesTable';

export const filter = (list: any[], value: any, loggedInUserId?: any) => {
	return list
		.filter((i) => {
			const val = Number(value);
			if (!isNaN(val) && value > 0) {
				return i.district.id == val;
			} else {
				return true;
			}
		})
		.filter((i) => {
			return true; // Temporarily disable as requested by client

			if (!loggedInUserId) {
				// console.log('No logged in user ID provided, returning all items:', i.id);
				return true;
			}

			if (i.teachers.length == 0) {
				console.log('No teachers found for student:', i.id);
				return false;
			} else {
				let found = false;
				i.teachers.forEach((t: Teacher) => {
					if (t.wpUserId == loggedInUserId) {
						found = true;
					}
				});
				return found;
			}

			return true;
		});
};

export type StageOption = {
	key: number;
	title: string;
};

const StagesTable = () => {
	const { palette } = useTheme();
	const { isHighContrast } = useCustomTheme();
	const { olympics } = useContext(OlympicsContext);
	const [tab, setTab] = useState(0);
	const { isAdmin } = useContext(AuthContext);
	const showStageThirdA = isAdmin || olympics?.thirdAStagePublished;
	const showStageThirdB = isAdmin || olympics?.thirdBStagePublished;
	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setTab(newValue);
	};

	return (
		<>
			<Grid
				item
				container
				justifyContent={'space-between'}
				sx={{
					borderBottom: 1,
					mt: 3,
					borderColor: 'divider',
				}}
			>
				<Tabs
					value={tab}
					onChange={handleTabChange}
				>
					<Tab
						label='Etap I'
						sx={{ color: isHighContrast ? palette.primary.main : 'inherit' }}
					/>
					<Tab
						label='Etap IIA'
						sx={{ color: isHighContrast ? palette.primary.main : 'inherit' }}
					/>
					<Tab
						label='Etap IIB'
						sx={{ color: isHighContrast ? palette.primary.main : 'inherit' }}
					/>
					{showStageThirdA && (
						<Tab
							label='Etap IIIA'
							sx={{ color: isHighContrast ? palette.primary.main : 'inherit' }}
						/>
					)}
					{showStageThirdB && (
						<Tab
							label='Etap IIIB'
							sx={{ color: isHighContrast ? palette.primary.main : 'inherit' }}
						/>
					)}
					<Tab
						label='Zbiorcze wyniki'
						sx={{ color: isHighContrast ? palette.primary.main : 'inherit' }}
					/>
				</Tabs>
			</Grid>
			{tab === 0 && <FirstStageTable />}
			{tab === 1 && <SecondAStageTable />}
			{tab === 2 && <SecondBStageTable />}
			{tab === 3 && <ThirdAStageTable />}
			{tab === 4 && <ThirdBStageTable />}
			{tab === 5 && <StudentsStagesTable />}
		</>
	);
};

export default StagesTable;
